module.exports = __webpack_public_path__ + "img/behaviour-1.69242306.gif";